<template>
  <van-col style="width: 100%; background-color: #F0F4FF;">
    <div class="enterprise-title">
      <div class="back-icon" @click="goBack">
        <span class="back-arrow"></span>
      </div>
      <div class="enterprise-text">修改密码</div>
    </div>
    <div class="form-container">
      <van-form @submit="onSubmit" :model="passwordForm">
        <div class="form-item">
          <div class="form-label"><van-icon name="lock" class="label-icon" />原密码</div>
          <van-field v-model="passwordForm.oldPwd" type="password" placeholder="请输入原密码" :rules="[{ required: true }]"
            clearable class="form-input" />
        </div>
        <div class="divider"></div>
        <div class="form-item">
          <div class="form-label"><van-icon name="lock" class="label-icon" />新密码</div>
          <van-field v-model="passwordForm.newPwd" type="password" placeholder="请输入新密码（至少6位）"
            :rules="[{ required: true }]" clearable class="form-input" />
        </div>
        <div class="divider"></div>
        <div class="form-item">
          <div class="form-label"><van-icon name="lock" class="label-icon" />确认密码</div>
          <van-field v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"
            :rules="[{ required: true }]" clearable class="form-input" />
        </div>
      </van-form>
    </div>

    <div style="height: 60vh;"></div>


    <!-- 按钮行 -->
    <div class="button-row">
      <van-button round block type="info" native-type="submit" class="btn-get-sub">保存</van-button>
      <div class="home-button" @click="goToHome">
        <van-icon name="wap-home" size="24" />
      </div>
    </div>

  </van-col>
</template>

<script>
import request from "@/utils/request";
import useCache from "@/utils/user";
import { Toast } from 'vant';

export default {
  name: 'ChangePassword',
  props: {
    source: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      passwordForm: {
        oldPwd: '',
        newPwd: '',
        confirmPassword: ''
      },
    };
  },
  mounted() {
  },
  methods: {
    onSubmit() {
      if (this.passwordForm.newPwd !== this.passwordForm.confirmPassword) {
        Toast("两次输入的新密码不一致");
        return;
      }
      const tempForm = Object.assign({}, this.passwordForm);
      request.post("/User/AccountMng/ChangePassword", tempForm).then(() => {
        Toast("密码修改成功");
        useCache.clearToken();
        this.$router.replace({
          name: 'login',
          query: { source: this.source }
        })
      }).catch(err => {
        Toast(err.message);
      })

    },
    // 返回首页
    goToHome() {
      this.$router.push("/credit/home");
    },
    // 返回上一页
    goBack() {
      this.$router.back();
    },
  }
};
</script>

<style lang="less">
.enterprise-title {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 12px;
  width: 100%;
  position: relative;
}

.back-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  z-index: 10;
  flex-shrink: 0;
}

.back-arrow {
  display: inline-block !important;
  width: 10px;
  height: 10px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: rotate(45deg);
  margin-right: 4px;
  visibility: visible !important;
  opacity: 1 !important;
}

.enterprise-text {
  position: absolute;
  left: 47.5%;
  transform: translateX(-50%);
  font-size: 18px;
  font-weight: 500;
}

.form-container {
  background-color: white;
  margin: 12px 16px 0;
  border-radius: 12px;
  padding: 10px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.form-item {
  display: flex;
  align-items: center;
}

.form-label {
  width: 80px;
  color: #333;
  font-size: 14px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.label-icon {
  margin-right: 6px;
  color: #176FCA;
}

.form-input {
  flex: 1;
  min-width: 0;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #e4e7ed;
  margin: 10px 0;
}

.form-button {
  margin-top: 30px;
}

.button-row {
  position: fixed;
  bottom: 20px;
  left: 16px;
  right: 16px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 999;
  justify-content: flex-end;
}

.home-button {
  width: 44px;
  height: 44px;
  background-color: #176FCA;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: background-color 0.3s;
  flex-shrink: 0;
}

.home-button:hover {
  background-color: #145EAB;
}

.btn-get-sub {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: #1566C1;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}
</style>